import { createTheme } from '@mui/material/styles';
import { tokens } from './tokens';
import { V4_COMPONENT_DEFAULTS, V4_TEXT_SECONDARY } from './v4Compat';

/**
 * The theme every `@mui/material` (v9) component draws with. Built from the same tokens as the v4 one.
 * The status palettes (error, warning, info, success) keep MUI's defaults: they carry meaning rather
 * than brand, and v4 and v9 already drew them differently before the theme existed.
 *
 * While v4 is still in the app, v9 components take v4's defaults where the two differ (`v4Compat.ts`), so a
 * migrated screen looks like its unmigrated neighbours.
 */
export const muiTheme = createTheme({
  palette: {
    primary: tokens.primary,
    secondary: tokens.secondary,
    text: { secondary: V4_TEXT_SECONDARY }
  },
  typography: {
    fontFamily: tokens.fontFamily
  },
  shape: {
    borderRadius: tokens.borderRadius
  },
  components: V4_COMPONENT_DEFAULTS
});
